import { useEffect, useState } from 'react';

import observer from 'saddlebag-observer';
import { showCookieBanner } from 'saddlebag-tracking-preferences';

import { isBrowser } from '../../../utils/isEnv';

const TRACKING_PREFERENCES_CHANGED = 'tracking-preferences-changed';

export const useCookieBannerDismissed = (
  market: string | undefined,
): boolean | null => {
  const [dismissed, setDismissed] = useState<boolean | null>(() => {
    if (!isBrowser() || !market) return null;
    return showCookieBanner(market) ? null : true;
  });

  useEffect(() => {
    if (!isBrowser() || !market || !showCookieBanner(market)) return undefined;

    const handler = () => {
      if (!showCookieBanner(market)) {
        setDismissed(true);
      }
    };

    const handle = observer.subscribe(TRACKING_PREFERENCES_CHANGED, handler);
    return () => observer.unsubscribe(handle);
  }, [market]);

  return dismissed;
};
